import { Component, OnInit } from '@angular/core';
import { DealModel } from 'src/app/models/deal.model';
import { DealsService } from 'src/app/services/deals.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { DealPipelineWorkflowService } from 'src/app/services/settings-services/deal-pipeline-workflow.service';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-deal-source-report',
  templateUrl: './deal-source-report.component.html',
  styleUrls: ['./deal-source-report.component.css']
})
export class DealSourceReportComponent implements OnInit {
  result;
  dealsData;
  dateUtil = new DateUtils;
  dateRange = { startDate: null, endDate: null };
  selectedIds = null;
  selectedType = null;
  dateType = '90';

  public chartOptions = {
    series: [
      {
        name: "total",
        data: []
      },
      {
        name: "lost",
        data: []
      },
      {
        name: "won",
        data: []
      },
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        // distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      title: {
        text: 'Source(s)',
      },
      categories: [],
    },
    colors: ["#0866C6","#DC3545",  "#00c851"],
    yaxis: {
      title: {
        text: 'Count',
      },
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      }
    }
  };
  constructor(
    private dealWorkSrv: DealPipelineWorkflowService,
    private performRepSrv: PerformanceReportService,
    private dealSrv: DealsService,
  ) {
    this.dateRange = this.dateUtil.getDefReportDateRange(Number(this.dateType));
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.handleDateFilter()
      }
    })
  }

  ngOnInit() {
    this.getSources();
  }
  dateChange({dateRange, dateType}) {
    this.dateRange = dateRange;
    this.dateType = dateType;
    this.handleDateFilter();
  }
  handleDateFilter() {
    this.result = false;
    this.getSources();
  }
  getSources() {
    this.dealWorkSrv.fetchDealSource().subscribe((res: any[]) => {
      this.chartOptions.xaxis.categories = res.map(d => d.name);
      const totalSrc = this.chartOptions.xaxis.categories.length;
      this.chartOptions.series[0].data = new Array(totalSrc).fill(0)
      this.chartOptions.series[1].data = new Array(totalSrc).fill(0)
      this.chartOptions.series[2].data = new Array(totalSrc).fill(0)
      this.getDeals();
    })
  }
  getDeals() {
    let filter: any = { dateFilter: this.dateRange }
    if (this.selectedType === 'salesperson') {
      filter = { ...filter, salesPerson: { ids: this.selectedIds } }
    }
    this.dealSrv.fetchDeals(this.selectedIds, filter).subscribe((datas: any[]) => {
      this.dealsData = datas;
      if (datas.length) {
        datas.forEach((dt, i, arr) => {
          this.update(dt);
          this.updateTotal(dt);
          if (arr.length - 1 == i) {
            this.result = true;
          }
        })
      } else {
        this.result = true;
      }
    })

  }
  update(deal: DealModel) {
    if (deal.status === 1 || deal.status === 2) {
      const sourceIndex = this.chartOptions.xaxis.categories.indexOf(deal.srcName);
      if (sourceIndex || sourceIndex === 0) {
        let srcCount: number = this.chartOptions.series[deal.status].data[sourceIndex];
        srcCount = srcCount + 1;
        this.chartOptions.series[deal.status].data[sourceIndex] = srcCount;
      }
    }
  }
  updateTotal(deal: DealModel) {
    const sourceIndex = this.chartOptions.xaxis.categories.indexOf(deal.srcName);
    let srcCount: number = this.chartOptions.series[0].data[sourceIndex];
    srcCount = srcCount + 1;
    this.chartOptions.series[0].data[sourceIndex] = srcCount;
  }
}
